export default __webpack_public_path__ + "static/media/docs.2b85fcc6.svg";